import { useContext, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { LangContext } from '../../context/LangContext';
import { useGoPage } from "../../hooks/useGoPage";

import TooltipPortal from '../../components/TooltipPortal';

import "./style.css"

import award_icon from '../../assets/svg/laurel_wreath.svg';
import lines_icon from '../../assets/svg/lines.svg';

function Onglet({ data, idx, getPath, lines }) {
    const goPage = useGoPage();
    const awardRefs = useRef({});

    const headerWidth = useSelector(state => state.options.headerWidth);
    const { language, translations } = useContext(LangContext);
    const [activeTooltip, setActiveTooltip] = useState(null);

    return (
        <button onClick={() => goPage(getPath(data))}>
            <div className="preview">
                <i style={{ backgroundImage: `url(${data.images[0][`${headerWidth < 700 ? '_' : ''}url`]})` }}></i>
                <p>- <span>{translations.view}</span> -</p>
            </div>

            <div className="descrip">
                <h2 className="title_serie">
                    - {data.title} -
                </h2>

                {lines && <img className='lines' src={lines_icon} alt=' ' />}

                <p className="genre_and_theme">
                    <span>{translations.genre} :</span>
                    {data.genre}
                </p>

                <p className="genre_and_theme">
                    <span>{translations.theme} :</span>
                    {data[`theme_${language}`]}
                </p>

                {data[`awards_${language}`].length !== 0 &&
                    <div className="awards">
                        <img
                            src={award_icon}
                            alt="Award(s)"

                            ref={el => awardRefs.current[idx] = el}
                            onMouseEnter={() => setActiveTooltip(idx)}
                            onMouseLeave={() => setActiveTooltip(null)}
                        />

                        <TooltipPortal
                            targetRef={{ current: awardRefs.current[idx] }}
                            show={activeTooltip === idx}
                        >
                            {data[`awards_${language}`].map((award, id) => (
                                <li key={id}>{award}</li>
                            ))}
                        </TooltipPortal>
                    </div>
                }
            </div>
        </button>
    )
}

export default Onglet;